export const BOTAO_CLICADO_SUCCESS = 'BOTAO_CLICADO_SUCCESS';
export const BOTAO_CLICADO_REQUEST = 'BOTAO_CLICADO_REQUEST';
export const BOTAO_CLICADO_FAILURE = 'BOTAO_CLICADO_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';

// Atualização do próprio perfil (PUT /users/me). Substitui o REGISTER_* antigo,
// que servia à tela Register em modo edição — removida por chamar
// `PUT /users` sem id, rota que nunca existiu no backend (handoff 0097 §6).
export const AUTH_USER_UPDATED = 'AUTH_USER_UPDATED';

// 2FA (novo fluxo)
export const AUTH_2FA_REQUIRED = 'AUTH_2FA_REQUIRED';
export const AUTH_2FA_CLEAR = 'AUTH_2FA_CLEAR';
export const AUTH_2FA_VERIFY_REQUEST = 'AUTH_2FA_VERIFY_REQUEST';
export const AUTH_2FA_VERIFY_FAILURE = 'AUTH_2FA_VERIFY_FAILURE';
export const AUTH_2FA_RESEND_REQUEST = 'AUTH_2FA_RESEND_REQUEST';
export const AUTH_2FA_RESEND_FAILURE = 'AUTH_2FA_RESEND_FAILURE';
